module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_3009.d44d98cc.png";